export default __webpack_public_path__ + "static/media/shell.468e1dbf.png";